import { createSelector } from '@reduxjs/toolkit';

import { selectIsRestorePage } from 'entities/siteSettings';

import { getPostFormTargetPageName } from './getPostFormTargetPageName';

export const selectPostFormTargetPageName = createSelector([selectIsRestorePage], getPostFormTargetPageName);
